import { Schema, arrayOf } from 'normalizr'

export const guide = new Schema('guides')
export const arrayOfGuides = arrayOf(guide)
